import { Component } from 'react';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form';

import { FormError, Layout, Title } from 'common/components/layout';
import { removeSpaces } from 'common/helpers/miscHelper';
import { integerFormat } from 'common/helpers/numberHelper';
import SubMenu from 'profile/common/SubMenu';
import { listClubMemberships } from 'redux/clubMemberships/actions';
import { getActiveClubMemberships } from 'redux/clubMemberships/reducers';
import {
  addCustomerCreditCard,
  listCustomerCreditCards
} from 'redux/customerCreditCards/actions';

import AddEditForm from '../components/AddEditForm';
import ClubMembershipCreditCardVerify from '../components/ClubMembershipCreditCardVerify';
import { isClubMembershipsWithoutThisCreditCard } from '../helpers';
import { validateAdd } from '../validators';

class CreditCardAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      creditCardId: null,
      isSubmitting: false
    };
  }

  componentDidMount() {
    const { props } = this;
    props.listCustomerCreditCards();
    props.listClubMemberships();
  }

  handleClubMembershipCreditCardVerify = (id) => {
    this.setState({
      modal: 'ClubMembershipCreditCardVerify',
      creditCardId: id
    });
  };

  handleSubmit = async (form) => {
    this.setState({
      isSubmitting: true
    });
    const { props } = this;
    const data = transformData(form);
    const { executeRecaptcha } = props.googleReCaptchaProps;
    const token = await executeRecaptcha('creditCardUpdate');
    data.recaptchaToken = token;
    const { activeClubMemberships } = this.props;
    let successFunction = () => {
      this.setState({
        isSubmitting: false
      });
      props.history.push('/profile/credit-card');
    };
    if (
      isClubMembershipsWithoutThisCreditCard(undefined, activeClubMemberships)
    ) {
      successFunction = (creditCard) => {
        this.handleClubMembershipCreditCardVerify(creditCard.id);
      };
    }
    props.addCustomerCreditCard(data, successFunction);
  };

  cancelFunction = () => {
    const { props } = this;
    props.history.push('/profile/credit-card');
  };

  handleCloseModal = () => {
    const { props } = this;
    this.setState({
      modal: null
    });
    props.history.push('/profile/credit-card');
  };

  render() {
    const { handleSubmit, form, customerCreditCards } = this.props;
    const { modal, creditCardId, isSubmitting } = this.state;
    const isFirstCard = customerCreditCards.recordCount === 0 || false;

    return (
      <Layout title="Add New Credit Card">
        <Title>Your Account</Title>
        <SubMenu />
        <div className="c7-account__credit-cards">
          <h2>Add new credit card</h2>
          <FormError formName={form} />
          <AddEditForm
            onSubmit={handleSubmit(this.handleSubmit)}
            saveButtonText={!isSubmitting ? 'Add Credit Card' : 'Loading...'}
            isFirstCard={isFirstCard}
            onCancelFunction={this.cancelFunction}
          />
        </div>
        {renderModal(modal, this.handleCloseModal, creditCardId)}
      </Layout>
    );
  }
}

const renderModal = (modal, handleCloseModal, creditCardId) => {
  switch (modal) {
    case 'ClubMembershipCreditCardVerify': {
      return (
        <ClubMembershipCreditCardVerify
          onCloseModal={handleCloseModal}
          creditCardId={creditCardId}
        />
      );
    }
    default: {
      return null;
    }
  }
};

const transformData = (values) => {
  const data = {
    cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
    expiryMo: values.expiryMo && integerFormat(values.expiryMo),
    expiryYr: values.expiryYr && integerFormat(values.expiryYr),
    cvv2: values.cvv2,
    cardHolderName: values.cardHolderName,
    isDefault: values.isDefault || false
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateAdd(data);
  return errors;
};

const mapStateToProps = (state) => ({
  customerCreditCards: state.customerCreditCard,
  activeClubMemberships: getActiveClubMemberships(state.clubMembership)
});

CreditCardAdd = reduxForm({
  form: 'Add Credit Card',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(CreditCardAdd);

export default withGoogleReCaptcha(
  withRouter(
    connect(mapStateToProps, {
      addCustomerCreditCard,
      listCustomerCreditCards,
      listClubMemberships
    })(CreditCardAdd)
  )
);
